module.exports = __webpack_public_path__ + "img/left_top_lv.2e344fbc.png";